import { Button, Col, Input, Row } from 'antd';
import { FilterOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons';

export function columnSearch(dataKey, searchCB, clearCB, filterCB) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <Row type="flex" gutter={2} style={{ padding: 10, borderRadius: 5 }}>
        <Col>
          <Input.Search
            enterButton // 回车触发搜索
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            placeholder="enter键确认搜索"
            onSearch={() => {
              confirm();
              searchCB && searchCB(selectedKeys[0], dataKey);
            }}
          />
        </Col>
        <Col>
          <Button
            onClick={() => {
              clearFilters();
              clearCB && clearCB(selectedKeys[0], dataKey);
            }}
            icon={<ReloadOutlined />}
          />
        </Col>
      </Row>
    ),
    onFilter: (value, record) => {
      if (!record[dataKey]) return false;
      const filter = record[dataKey]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
      if (filter) {
        filterCB && filterCB(record, value, dataKey);
        console.log(JSON.stringify(record)); // 打印结果
      }
      return filter;
    },
    filterIcon: () => <SearchOutlined />,
  };
}

export function columnSearch2(dataKey, searchCB, clearCB, filterCB) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <Row type="flex" gutter={2} style={{ padding: 10, borderRadius: 5 }}>
        <Col>
          <Input.Search
            enterButton // 回车触发搜索
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            placeholder="enter键确认搜索"
            onSearch={() => {
              searchCB && searchCB(selectedKeys[0], dataKey, true);
            }}
          />
        </Col>
        <Col>
          <Button
            onClick={() => {
              searchCB && searchCB(selectedKeys[0], dataKey, false);
              clearFilters();
            }}
            icon={<ReloadOutlined />}
          />
        </Col>
      </Row>
    ),
    onFilter: (value, record) => {
      if (!record[dataKey]) return false;
      const filter = record[dataKey]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
      if (filter)
        filterCB && filterCB(record, value, dataKey)
      return filter
    },
    filterIcon: () => <SearchOutlined />,
  };
}

export function columnSearchSort(dataKey, searchCB, clearCB, filterCB) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <Row type="flex" gutter={2} style={{ padding: 10, borderRadius: 5 }}>
        <Col>
          <Input.Search
            enterButton // 回车触发搜索
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            placeholder="enter键确认搜索"
            onSearch={() => {
              confirm();
              searchCB && searchCB(selectedKeys[0], dataKey);
            }}
          />
        </Col>
        <Col>
          <Button
            onClick={() => {
              clearFilters();
              clearCB && clearCB(selectedKeys[0], dataKey);
            }}
            icon={<ReloadOutlined />}
          />
        </Col>
      </Row>
    ),
    onFilter: (value, record) => {
      if (!record[dataKey]) return false;
      const filter = record[dataKey]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
      if (filter)
        filterCB && filterCB(record, value, dataKey)
      return filter
    },
    filterIcon: () => <FilterOutlined />,
  };
}

// 批量筛选
export function filterColumnSearch(dataKey) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <Row type="flex" gutter={2} style={{ padding: 10, borderRadius: 5 }}>
        <Col>
          <Input.Search
            enterButton // 回车触发搜索
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            placeholder="enter键确认搜索"
            onSearch={() => {
              confirm();
            }}
          />
        </Col>
        <Col>
          <Button
            onClick={() => {
              clearFilters();
            }}
            icon={<ReloadOutlined />}
          />
        </Col>
      </Row>
    ),
    onFilter: (value, record) => {
      if (!record[dataKey]) return false;
      const standardizedValue = value.replace(/，/g, ',').toLowerCase();
      const filterValues = standardizedValue.toLowerCase().split(',');
      const filter = filterValues.some((filterValue) =>
        record[dataKey].toString().toLowerCase().includes(filterValue.trim())
      );
      return filter;
    },
    filterIcon: () => <SearchOutlined />,
  };
}

export function mergeCells(value, index, dataList, predicate = () => true) {
  const obj = {
    children: value,
    props: {},
  };
  let i = index - 1;
  if (dataList[i] && predicate(dataList[i])) {
    obj.props.rowSpan = 0;
  } else {
    i = index + 1;
    while (dataList[i] && predicate(dataList[i])) i++;
    obj.props.rowSpan = i - index;
  }
  return obj;
}

export const sorteColum = (compare, multiple) => {
  if (typeof compare === 'string') {
    return {
      compare: (f, b) => ((Number.parseFloat(f[compare])) - (Number.parseFloat(b[compare]))),
      multiple
    }
  }
  return { compare, multiple }
}

/**
 * 分组
 * @param {Object} arr 需要进行分组的数组
 * @param {Object} filed 按什么字段进行分组
 * @returns
 */
export function groupBys(arr, filed) {
  const temp = {};

  arr.map(item => {
    const key = item[filed]
    if (!temp[key])
      temp[key] = [];
    temp[key].push(item);

  });
  return temp;
}

//这里如果想要按照name进行分组即如下：const results = GroupBy(list, function (item) {return [item.name];});
/**
 * @param {Array} groupByarr 要分组的数组
 * @param {Array<String>} aggFileds 分组依赖字段
 * @returns {Object} groupObject 分组后对象
 */
export function aggreArrItem(groupByarr, aggFileds) {
  let aggTemp = groupByarr[0]
  const filed = aggFileds.length === 1 ? aggFileds[0] : undefined
  if (groupByarr.length > 1) {
    const reduce = groupByarr.reduce((item1, item2) => {
      let add = {}
      if (filed) {
        add[filed] = item1[filed] + item2[filed]
      } else {
        aggFileds.map(filed => {
          add[filed] = item1[filed] + item2[filed]
        })
      }
      return add
    })
    aggTemp = { ...aggTemp, ...reduce }
  }
  return aggTemp;
}

/**
 *  将分组后各个数组聚合成一个对象
 * @param {Object} groupObject 使用groupBys分组后对象
 * @param {Array<String>} aggFileds 需要聚合的的字段
 * @param {Object} gpKeys 分组的key集合,如果没传，则取{groupObject}的key
 */
export function groupBysAggreObject(groupObject, aggFileds, gpKeys) {
  if (gpKeys?.length > 0) {
    return gpKeys.map(key => aggreArrItem(groupObject[key], aggFileds))
  } else {
    return Object.keys(groupObject).map(key => aggreArrItem(groupObject[key], aggFileds))
  }
}


/**
 * 将匹配的数组元素计算差值，minuteOriArr减去匹配到的 minutesArr
 * @param {Array<Object>} minuteOriArr 被减数数组
 * @param {Array<Object>} minutesArr 件数数组
 * @param {Array<String>} aggFileds 哪些字段需要相减
 * @param {Function->bool} matchCall 匹配条件
 * @returns Array<Object>，长度与minuteOriArr一致
 */
export function calculateDiff(minuteOriArr, minutesArr, aggFileds, matchCall) {
  const filed = aggFileds.length === 1 ? aggFileds[0] : undefined
  return minuteOriArr.map(minOritem => {
    const matchFind = minutesArr.find((minutesItem, i) => matchCall(minOritem, minutesItem, i))
    const temp = {}
    if (!!matchFind) {
      if (filed) {
        temp[filed] = Math.abs(numberConver(minOritem[filed])) - numberConver(Math.abs(matchFind[filed]))
      } else {
        aggFileds.map(filed => {
          temp[filed] = Math.abs(numberConver(minOritem[filed])) - numberConver(Math.abs(matchFind[filed]))
        })
      }
    }
    return { ...minOritem, ...temp }
  })
}

const numberConver = (num) => {
  return Number.parseFloat(num.toFixed(4))
}
